const routerArr = [
  {
      path: '/learning',
      name: 'learning',
      meta: { title:'学习中心列表' ,login:true},
      component: () => import(/* webpackChunkName: 'learning' */ './page/index.vue'),
  },
  {
      path: '/learning/Details',
      name: 'learningDetails',
      meta: { title:'学习详情' ,login:true},
      component: () => import(/* webpackChunkName: 'learning' */ './page/learningDetails.vue'),
  },
  {
      path: '/learning/list',
      name: 'learningList',
      meta: { title:'训练营列表',login:true },
      component: () => import(/* webpackChunkName: 'learning' */ './page/learningList.vue'),
  },
  {
    path: '/training/list',
    name: 'trainingList',
    meta: { title:'学习',login:true },
    component: () => import(/* webpackChunkName: 'learning' */ './page/taskList.vue'),
  },
  {
    path: '/learning/Detailstrain',
    name: 'trainDetails',
    meta: { title:'学习' ,login:true},
    component: () => import(/* webpackChunkName: 'learning' */ './page/trainDetails.vue'),
  },
  {
    path: '/learning/formPage',
    name: 'formPage',
    meta: { title:'表单',login:true },
    component: () => import(/* webpackChunkName: 'learning' */ './page/formPage.vue'),
  },
  {
    path: '/subscribeList',
    name: 'subscribeList',
    meta: { title:'表单',login:true },
    component: () => import(/* webpackChunkName: 'learning' */ './page/subscribeList.vue'),
  },
  {
    path: '/learning/task/detail',
    name: 'taskDetail',
    meta: { title:'任务详情',login:true },
    component: () => import(/* webpackChunkName: 'learning' */ './page/taskDetail.vue'),
  },
  {
    path: '/learning/scrom',
    name: 'PlayScrom',
    meta: { title:'Scrom',login:true },
    component: () => import(/* webpackChunkName: 'learning' */ './page/scrom/index.vue'),
  },
  {
    path: '/learning/signature',
    name: 'signature',
    meta: { title:'signature',login:true },
    component: () => import(/* webpackChunkName: 'learning' */ './page/signature.vue'),
  }
]

export default routerArr